import { createAction } from 'redux-actions';

const MODULE = 'app/admin/history';

const FETCH_HISTORY_REQUEST = `${MODULE}/FETCH_HISTORY_REQUEST`;
const FETCH_HISTORY_RESPONSE = `${MODULE}/FETCH_HISTORY_RESPONSE`;

export const fetchHistoryRequest = createAction(FETCH_HISTORY_REQUEST);
export const fetchHistoryResponse = createAction(FETCH_HISTORY_RESPONSE);
